/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('selected-variant-id') || $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').attr('data-selected-variant-id') || $('.product-detail:not(".bundle-item")').data('selected-variant-id') || $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

module.exports = {
    getPidValue: getPidValue
};
